import type { AppState, HubPersonasMap, ContactFoldersState } from '..';
import { HubPersona, createSelector, uniq } from '../../shared';

/**
 * Retrieves all the personas stored in contact folders
 */
export const getAllHubPersonasAcrossFolders = createSelector<
    AppState,
    HubPersonasMap,
    ContactFoldersState,
    HubPersona[]
>(
    'getAllHubPersonas',
    [
        (appState: AppState) => appState.data.personas,
        (appState: AppState) => appState.data.contactFoldersState,
    ],
    (hubPersonasMap, contactFoldersState) => {
        const folderIdToHubPersonaIds = contactFoldersState.folderIdToHubPersonaIds;
        const allHubIds = Object.keys(folderIdToHubPersonaIds)
            .map(folderId => folderIdToHubPersonaIds[folderId] || [])
            .reduce((result, value) => {
                return result.concat(value);
            }, []);
        const uniqueHubIds = uniq(allHubIds);

        return uniqueHubIds.map(personaHubId => hubPersonasMap[personaHubId]);
    }
);
